import { get } from "lodash";

export default function isRecentDraw(data) {
  return (
    get(data, "project.recentDraw.id", "") === get(data, "project.draw.id", "")
  );
}
